<template>
 <div style="position:absolute; width:100%;">
   <v-toolbar class="bar" dense elevation="0" color="transparent" max-height="48px">
    <v-btn icon small @click="$emit('cancel')">
      <v-icon small>mdi-close</v-icon>
    </v-btn>
    <v-toolbar-title class="body-2 pl-2 font-weight-medium">{{liveList ? 'Лист живой очереди' : 'Лист ожидания'}}</v-toolbar-title>

    <template v-if="!liveList">
      <tooltip bottom>
        <v-btn class="ml-3" small depressed icon depresse @click="filter.groupById=!filter.groupById" :color="!filter.groupById ? 'primary' : 'grey'">
          <v-icon>mdi-sort-calendar-ascending</v-icon>
        </v-btn>
        <template v-slot:content>
          Сортировка по планируемой дате
        </template>
      </tooltip>

      <tooltip bottom>
        <v-btn class="ml-1" small depressed icon depresse @click="filter.groupById=!filter.groupById" :color="filter.groupById ? 'primary' : 'grey'">
          <v-icon>mdi-sort-numeric-ascending</v-icon>
        </v-btn>
        <template v-slot:content>
          Сортировка по порядку добавления
        </template>
      </tooltip>
  </template>
    <v-spacer/>
    <v-btn @click="clientSearchState.modalOpen()" depressed small>Добавить</v-btn>
   </v-toolbar>

   <v-divider></v-divider>

   <v-toolbar class="bar" dense elevation="0"  color="transparent" >
      <v-checkbox
          v-if="!liveList"
          v-model="currentDayOnly"
          label="Только текущий день"
          class="mt-4"
        ></v-checkbox>
        <text-field v-if="liveList" v-show="searchOpen" class="mb-0" name="Поиск" :value.sync="searchQuery" clearable/>
        <v-spacer></v-spacer>
        
        <v-btn
        class="mx-2"
        fab
        dark
        x-small
        depressed
        :color="searchOpen ? 'primary' : 'grey'"
        @click="searchOpen = !searchOpen;searchQuery=null"
      >
        <v-icon dark>
          mdi-magnify
        </v-icon>
      </v-btn>
    </v-toolbar> 

    <text-field v-if="!liveList" v-show="searchOpen" class="mx-4" name="Поиск" :value.sync="searchQuery" clearable/>
    
   <div v-if="dataState.isLoading" class="text-center pt-4">
     <v-progress-circular indeterminate color="primary"/>
   </div>
   <div v-if="dataState.isSuccess">
     <v-sheet :height="height-48" class="overflow-y-auto pb-15">
      <template v-if="filterUserSpec.length>0">
       <v-chip  v-for="userSpec in filterUserSpec" :key="userSpec.id" class="mb-2 mx-4" small :close="true" @click:close="$emit('update:filterUserSpec',filterUserSpec.filter(i=>i.id!==userSpec.id));load()">
         {{userSpec.user.lastName=== null ? '': userSpec.user.lastName}}
         {{userSpec.user.firstName=== null ? '': userSpec.user.firstName}}
         {{userSpec.user.secondName=== null ? '': userSpec.user.secondName}}
       </v-chip>
      </template>
      <template v-if="filterSpec.length>0">
        <v-chip v-for="spec in filterSpec"  :key="spec.id" class="mb-2 mx-4" small :close="true" @click:close="$emit('update:filterSpec', filterSpec.filter(i=>i.id!==spec.id));load()">
          {{spec.name}}
        </v-chip>
       </template>
       <v-list v-if="visitPlans.length>0" class="pa-0 pb-5">
         <v-list-item
             v-for="(visitPlan, k) in visitPlans" :key="'visitPlan'+k"
              
             @click="visitPlanState.modalOpen(visitPlan)">
           <v-list-item-content>
             <v-list-item-title>
               <div class="font-weight-medium mb-1">
                 {{visitPlan.user.lastName=== null ? '': visitPlan.user.lastName}}
                 {{visitPlan.user.firstName=== null ? '': visitPlan.user.firstName}}
                 {{visitPlan.user.secondName=== null ? '': visitPlan.user.secondName}}
               </div>
               <div class="caption mb-1">К специалисту{{visitPlan.isLiveList ? '': ' '+$tools.date(visitPlan.begin)}}:</div>
               <v-row v-if="visitPlan.userSpec!==null" no-gutters class="align-center">
                 <v-col cols="auto">
                   <v-avatar class="user" size="32">
                     <img :src="visitPlan.userSpec.user.imageUrl" v-if="visitPlan.userSpec.user.imageUrl" alt="">
                   </v-avatar>
                 </v-col>
                 <v-col class="pl-2">
                   <div class="font-weight-medium">
                     {{visitPlan.userSpec.user.lastName=== null ? '': visitPlan.userSpec.user.lastName}}
                     {{visitPlan.userSpec.user.firstName=== null ? '': visitPlan.userSpec.user.firstName}}
                     {{visitPlan.userSpec.user.secondName=== null ? '': visitPlan.userSpec.user.secondName}}
                   </div>
                   <div class="caption text-wrap">
                     {{visitPlan.userSpec.spec.name}}
                     <v-icon small>mdi-chevron-left</v-icon>
                     {{visitPlan.userSpec.comDiv.comBranch.name}}
                     <div v-if="!$tools.isEmpty(visitPlan.userSpec.commentAdmin)" class="caption">
                       <v-icon class="mr-1" small>mdi-comment-text-outline</v-icon>
                       {{visitPlan.userSpec.commentAdmin}}
                     </div>
                   </div>
                 </v-col>
               </v-row>
               <div v-else-if="visitPlan.spec!==null" class="font-weight-medium">
                 {{visitPlan.spec.name}}
               </div>
               <div v-if="!$tools.isEmpty(visitPlan.comment)" class="mt-1">
                 <div class="caption">Комментарий:</div>
                 <div class="caption">{{visitPlan.comment}}</div>
               </div>
             </v-list-item-title>
           </v-list-item-content>
         </v-list-item>
       </v-list>
       <alert-view v-else icon="mdi-information-outline" text="Не найдено" />
     </v-sheet>
   </div>
   <visit-plan
       :state="visitPlanState"
       :usersSpecs="usersSpecs"
       @cancel="visitPlanState.modalClose()"
       @createdUpdatedDeleted="visitPlanState.modalClose();load();$emit('visitPlansUpdated')"
       @visitCreate="visitCreate"
       @open="(v)=>visitPlanState.modalOpen(v)"
   />
   <client-search-or-create
    :state="clientSearchState"
    :dataFromCaller.sync="dataFromCaller"
    @cancel="clientSearchState.modalClose();load();$emit('clearDataFromCaller')"
    @userSelected="clientSelected"
    @userCreate="clientSelected"
   />
 </div>
</template>

<script>
import State from "@/plugins/state";
// import axios from "axios";
// import Api from "@/Api";
import AlertView from "@/components/AlertView";
import VisitPlan from "@/views/Visit/VisitPlan";
import ClientSearchOrCreate from "@/views/User/Client/ClientSearchOrCreate";
import moment from "moment";
import TextField from "@/componentsV2/base/TextField.vue";
import Tooltip from "@/componentsV2/base/Tooltip.vue";
import {
  Entity_VisitPlan,
  Entity_User,
  Entity_UserSpec,
  Entity_Spec,
  Entity_ComDiv,
  Entity_ComBranch
} from "../../../EntityStoreCacheService";


export default {
  components: {
    ClientSearchOrCreate, 
    VisitPlan, 
    AlertView, 
    TextField,
    Tooltip
  },
  props:['usersSpecs','height','filterUserSpec','filterSpec','filterComBranch','daySelected','liveList','dataFromCaller'],
  data: () => ({
    dataState: new State(),
    visitPlans:[],
    visitPlanState: new State(),
    clientSearchState: new State(),
    currentDayOnly: true,
    searchOpen: false,
    searchQuery: null,
    filter: {
      groupById: false
    }
  }),
  mounted() {
    // фильтр из localStorage
    const filterSettings = localStorage.getItem('visitPlansFilter');
    if (localStorage.visitPlansFilter!==undefined&&filterSettings!==null)
      this.filter = JSON.parse(filterSettings);

    this.load();
  },
  watch:{
    filter: {
      handler() {
        //сохраняем фильтры в localStorage
        localStorage.setItem('visitPlansFilter', JSON.stringify(this.filter));
        this.load()
      },
      deep: true,
    },
    dataFromCaller() {
      this.load()
    },
    daySelected(){
      this.load();
    },
    liveList(){
      this.load();
    },
    filterUserSpec(){
      this.load();
    },
    filterSpec(){
      this.load();
    },
    filterComBranch() {
      this.load();
    },
    currentDayOnly() {
      this.load();
    },
    searchQuery(){
      this.$tools.debounce(()=>{
        this.load();
      },300);
    }
  },
  methods:{
    openSearchModalOrAddCurrentUser(){ 
      if (this.dataFromCaller?.user !== undefined&&this.dataFromCaller?.type !== undefined) {
        this.clientSelected(this.dataFromCaller.user)              
        //clear data from caller
        this.$emit('clearDataFromCaller')
      } else if (this.dataFromCaller?.phone !== undefined&&this.dataFromCaller?.type !== undefined) {
        this.clientSearchState.modalOpen();
      }
    },
    load(){
      let rb = new Entity_VisitPlan()
      .selects(Entity_VisitPlan.id)
      .selects(Entity_VisitPlan.begin)
      .selects(Entity_VisitPlan.comment)
      .selects(Entity_VisitPlan.isLiveList)

      //spec
      .selects([Entity_VisitPlan.spec, Entity_Spec.id].join('.'))
      .selects([Entity_VisitPlan.spec, Entity_Spec.name].join('.'))

      //user
      .selects([Entity_VisitPlan.user, Entity_User.id].join('.'))
      .selects([Entity_VisitPlan.user, Entity_User.firstName].join('.'))
      .selects([Entity_VisitPlan.user, Entity_User.secondName].join('.'))
      .selects([Entity_VisitPlan.user, Entity_User.lastName].join('.'))
      .selects([Entity_VisitPlan.user, Entity_User.phone].join('.'))
      
      //userSpec
      .selects([Entity_VisitPlan.userSpec, Entity_UserSpec.id].join('.'))
      .selects([Entity_VisitPlan.userSpec, Entity_UserSpec.spec, Entity_Spec.id].join('.'))
      .selects([Entity_VisitPlan.userSpec, Entity_UserSpec.spec, Entity_Spec.name].join('.'))
      .selects([Entity_VisitPlan.userSpec, Entity_UserSpec.commentAdmin].join('.'))
      .selects([Entity_VisitPlan.userSpec, Entity_UserSpec.comDiv, Entity_ComDiv.comBranch, Entity_ComBranch.id].join('.'))
      .selects([Entity_VisitPlan.userSpec, Entity_UserSpec.comDiv, Entity_ComDiv.comBranch, Entity_ComBranch.name].join('.'))
      .selects([Entity_VisitPlan.userSpec, Entity_UserSpec.user, Entity_User.id].join('.'))
      .selects([Entity_VisitPlan.userSpec, Entity_UserSpec.user, Entity_User.firstName].join('.'))
      .selects([Entity_VisitPlan.userSpec, Entity_UserSpec.user, Entity_User.secondName].join('.'))
      .selects([Entity_VisitPlan.userSpec, Entity_UserSpec.user, Entity_User.lastName].join('.'))
      .selects([Entity_VisitPlan.userSpec, Entity_UserSpec.user, Entity_User.imageUrl].join('.'))

 
      //filter begin
      rb.filterAnd([Entity_VisitPlan.entity, Entity_VisitPlan.begin].join('.')+'>=?',moment(this.daySelected, 'YYYY-MM-DD').format('YYYY-MM-DD 00:00:00'));
      if (this.currentDayOnly)
        rb.filterAnd([Entity_VisitPlan.entity, Entity_VisitPlan.begin].join('.')+'<=?',moment(this.daySelected, 'YYYY-MM-DD').format('YYYY-MM-DD 23:59:59'));
      
      //filter by userSpec
      if(this.filterUserSpec.length>0)
        rb.filterAnd([Entity_VisitPlan.entity, Entity_VisitPlan.userSpec, Entity_UserSpec.user, Entity_User.id].join('.')+' in (?)',this.filterUserSpec.map(i=>i.user.id));
      
      //filter by spec
      if(this.filterSpec.length>0)
        rb.filterAnd([Entity_VisitPlan.entity, Entity_VisitPlan.userSpec, Entity_UserSpec.spec, Entity_Spec.id].join('.') +' in (?) OR ' +
        [Entity_VisitPlan.entity, Entity_VisitPlan.spec, Entity_Spec.id].join('.') +' in (?)',
        this.filterSpec.map(i=>i.id),this.filterSpec.map(i=>i.id));

      //filter by comBranch
      if (this.filterComBranch.length>0)
        rb.filterAnd([Entity_VisitPlan.entity, Entity_VisitPlan.userSpec, Entity_UserSpec.comDiv, Entity_ComDiv.comBranch, Entity_ComBranch.id].join('.')+' in (?)',this.filterComBranch.map(i=>i.id));

      // filter liveList
      rb.filterAnd([Entity_VisitPlan.entity, Entity_VisitPlan.isLiveList].join('.')+'=?',this.liveList ? 1 : 0);  

      //filter
      if (this.searchQuery) {
        let arr = this.searchQuery.split(' ');
        if (arr.length === 1) {
          rb.filterAnd([Entity_VisitPlan.entity, Entity_VisitPlan.userSpec, Entity_UserSpec.user, Entity_User.lastName].join('.') + ' LIKE ? OR '+
          [Entity_VisitPlan.entity, Entity_VisitPlan.user, Entity_User.lastName].join('.') + ' LIKE ? ', arr[0] + '%', arr[0] + '%')
        } else if (arr.length === 2) {
          rb.filterAnd([Entity_VisitPlan.entity, Entity_VisitPlan.userSpec, Entity_UserSpec.user, Entity_User.lastName].join('.') + ' LIKE ? OR '+
          [Entity_VisitPlan.entity, Entity_VisitPlan.user, Entity_User.lastName].join('.') + ' LIKE ? ', arr[0] + '%', arr[0] + '%')
          rb.filterAnd([Entity_VisitPlan.entity, Entity_VisitPlan.userSpec, Entity_UserSpec.user, Entity_User.firstName].join('.') + ' LIKE ? OR '+
          [Entity_VisitPlan.entity, Entity_VisitPlan.user, Entity_User.firstName].join('.') + ' LIKE ? ', arr[1] + '%', arr[1] + '%')
        } else if (arr.length === 3) {
          rb.filterAnd([Entity_VisitPlan.entity, Entity_VisitPlan.userSpec, Entity_UserSpec.user, Entity_User.lastName].join('.') + ' LIKE ? OR '+
          [Entity_VisitPlan.entity, Entity_VisitPlan.user, Entity_User.lastName].join('.') + ' LIKE ? ', arr[0] + '%', arr[0] + '%')
          rb.filterAnd([Entity_VisitPlan.entity, Entity_VisitPlan.userSpec, Entity_UserSpec.user, Entity_User.firstName].join('.') + ' LIKE ? OR '+
          [Entity_VisitPlan.entity, Entity_VisitPlan.user, Entity_User.firstName].join('.') + ' LIKE ? ', arr[1] + '%', arr[1] + '%')
          rb.filterAnd([Entity_VisitPlan.entity, Entity_VisitPlan.userSpec, Entity_UserSpec.user, Entity_User.secondName].join('.') + ' LIKE ? OR '+
          [Entity_VisitPlan.entity, Entity_VisitPlan.user, Entity_User.secondName].join('.') + ' LIKE ? ', arr[2] + '%', arr[2] + '%')
        }
      }

      if (!this.filter.groupById&&!this.liveList)
        rb.order([Entity_VisitPlan.begin].join('.'), true)
      else
        rb.order([Entity_VisitPlan.id].join('.'), true)

      rb.page(1).onPage(1000)
      rb.addStateCallback((v)=> this.dataState.setRequestBuilderState(v))
      .request((v)=>{
        this.visitPlans = v.items;

        //for dataFromCaller
        this.openSearchModalOrAddCurrentUser()

      }, (e)=>{
        console.error(e.response.data.message);
      })
    },
    clientSelected(v){
      this.clientSearchState.modalClose();
      let lL = this.liveList

      if (this.dataFromCaller?.type === 'liveList') {
        lL = true
      } else if (this.dataFromCaller?.type === 'waitingList') {
        lL = false
      }

      this.visitPlanState.modalOpen({
        user:v,
        isLiveList: lL
      })

      this.$emit('clearDataFromCaller');
    },
    visitCreate(v){
      this.visitPlanState.modalClose();
      this.$emit('visitCreate', v);
    }
  }
}
</script>